import DataSource from "../DataSource";

export default class ForecastDataService {
  constructor(server, FileService) {
    this.server = server;
    this.FileService = FileService;
  }

  getOPM(type) {
    return this.server('forecast.data.opm.get', {
      type: type
    });
  }

  getMonthCalendar(idOPM, date, commodityType) {
    var data = {
      idOPM: idOPM,
      date: date,
      commodityType: commodityType
    };

    return this.server("forecast.data.month.get", { data: data })
  }

  saveMonthCalendar(idOPM, date, commodityType, data) {
    return this.server("forecast.data.month.save", {
      idOPM: idOPM,
      date: date,
      commodityType: commodityType,
      data: data
    })
  }

  importFile(file, idOPM, date, commodityType) {
    return this.FileService
      .read(file)
      .then(file =>
        this.server("forecast.data.file.import", {
          file: file,
          data: {
            idOPM: idOPM,
            date: date,
            commodityType: commodityType
          }
        })
      );
  }

  sendActualData(idOPM, date, commodityType, locale) {
    return this.server("forecast.report.actual.send", {
      idOPM: idOPM,
      date: date,
      commodityType: commodityType,
      locale: locale
    })
  }
  
  getEmptyXls(date, firstDay, locale) {
    window.open(this.server.getRequestUrl("forecast.data.default.xls", {date: encodeURIComponent(date), firstDay: firstDay, locale: locale}));
  }
}



// WEBPACK FOOTER //
// ./src/ForecastData/ForecastDataService.js